// extracted by mini-css-extract-plugin
module.exports = {"success":"_2-H1M","circle":"Ml+4r","text":"WDlnj","success_no_paddings":"_2R8bf"};